<div *ngIf="!loading" class="association-picker">
  <div class="mr-1">
    <div class="title">Kies hier de gewenste sticker</div>
    <mat-form-field appearance="outline">
      <mat-select
        matInput
        [disabled]="readOnly"
        [placeholder]="'Maak een keuze'"
        [(value)]="selectedOption"
        (selectionChange)="setOptionValue($event.value)"
      >
        <mat-option *ngFor="let option of associationOptions" [value]="option">
          {{ option.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div
    *ngIf="selectedOption != null && selectedOption.value === null"
    class="other-value-input"
  >
    <mat-form-field appearance="outline">
      <input
        matInput
        [disabled]="readOnly"
        placeholder="{{ otherValuePlaceholder }}"
        [(ngModel)]="otherValue"
        (ngModelChange)="setOtherValue()"
      />
    </mat-form-field>
  </div>
</div>
